import { GlobalState } from '@leverege/ui-redux';
import { useEffect, useMemo, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { DateTime } from 'luxon';
export default function useRsrcImage({
  item,
  delegate
}) {
  const {
    ref,
    inView
  } = useInView();
  const [src, setSrc] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const isImage = item?.data?.type?.startsWith('image/');
  useEffect(() => {
    if (!inView) {
      return;
    }
    if (isImage) {
      const rsrc = delegate.item(item.data.path).getItem();
      if (rsrc) {
        const url = new URL(rsrc.data.url);
        let expiresDate;
        if (url.searchParams.has('Expires')) {
          const expires = url.searchParams.get('Expires');
          expiresDate = DateTime.fromMillis(parseInt(expires) * 1000);
        } else if (url.searchParams.has('X-Goog-Date')) {
          const expiresIn = parseInt(url.searchParams.get('X-Goog-Expires'));
          const validAtDate = DateTime.fromISO(url.searchParams.get('X-Goog-Date'));
          expiresDate = validAtDate.plus({
            seconds: expiresIn
          });
        }
        if (!expiresDate) {
          setError(true);
          return;
        }
        const now = DateTime.now();
        if (expiresDate && expiresDate > now) {
          setSrc(rsrc.data.url);
          setLoading(false);
          setError(false);
          return;
        }
      }
      setLoading(true);
      if (!error) {
        GlobalState.dispatch(delegate.item(item.data.path).get()).then(res => {
          setSrc(res.data.url);
          setLoading(false);
          return res;
        }).catch(err => {
          setError(err);
          setLoading(false);
        });
      }
    } else {
      setSrc('https://storage.googleapis.com/molten-ui-assets/no_image_available.jpg');
      setLoading(false);
    }
  }, [delegate, src, item, inView, isImage, error]);
  return useMemo(() => {
    return {
      src,
      loading,
      ref,
      inView
    };
  }, [src, loading, ref, inView]);
}